require('initializers/gettext').default(__TRANSLATIONS__.gettext.da); // eslint-disable-line no-undef
require('initializers/i18n').default('da', __TRANSLATIONS__.i18n.da); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/da');
require('jquery-ui/ui/i18n/datepicker-da');
require('dayjs/locale/da');
